import { render, staticRenderFns } from "./MinYueBao.vue?vue&type=template&id=3690f7a2&scoped=true&"
import script from "./MinYueBao.vue?vue&type=script&lang=js&"
export * from "./MinYueBao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690f7a2",
  null
  
)

export default component.exports